import React, {ReactElement} from "react";
import "./Toggle.css";

function Toggle({choices, selected, onSelect, label, info, disabled=false}: {choices: string[], selected: string, onSelect: any, label: string, info?: ReactElement, disabled?: boolean}) {
    return <div className={disabled ? "labeled-toggle disabled" : "labeled-toggle"}>
        <div className="toggle-label">
            <div className="text">{label}</div>
        </div>
        <div className="toggle">
            {choices.map((option) => {
                let className = "toggle-option"
                if (selected === option) {
                    className += " selected"
                }
                return <div key={option} className={className} onClick={() => {
                    if(disabled) return;
                    onSelect(option)
                }}>{option}</div>
            })}
        </div>
        {info}
    </div>
}

export default Toggle